export const PAGE_TYPES = {
	BASIC: 'premiumBasicPage',
	BASIC_WITH_SUB_ITEMS: 'premiumBasicPageWithChildren',
	PAGE_FOLDER: 'pageFolder',
	HOME: 'premiumHomePage',
	EVENT_LIST: 'premiumEventList',
	EVENT: 'premiumEventPage',
	NEWS_LIST: 'premiumNewsListPage',
	NEWS: 'premiumNewsPage',
	MEMBER_PORTAL_EVENT_LIST: 'memberPortalEventListPage',
	MEMBER_PORTAL_LOGIN: 'memberPortalLoginPage',
	MEMBER_PORTAL_REPRESENTATIVES: 'memberPortalRepresentativesPage'
};
